import React from "react";
import Header from "../common/Header";
import FrequentlyAskedQuestions from "./FrequentlyAskedQuestions";

function Faq() {
  return (
    <>
      <div className="bg-white rounded-2xl h-[calc(100vh-32px)] overflow-x-hidden">
        <div className="   px-2 xs:px-5  relative  overflow-x-hidden">
          <div className=" overflow-hidden">
            <Header text="FAQ’s" />
          </div>
          <div className=" ">
            <FrequentlyAskedQuestions />
          </div>
        </div>
      </div>
    </>
  );
}

export default Faq;
